export enum PayrollVariant {
  scorp = 'scorp',
  group = 'group',
  general = 'general',
}
